(function($) {

  // Seleziona gli elementi "qty trigger" e associa un gestore di eventi "click"
  var qtyBtnTrigger = $('.js-qty-trigger');
  qtyBtnTrigger.each(function() {
    var $this = $(this);
    var btnQty = $this.next('.js-btn-qty');

    // Nasconde il pulsante attuale e mostra il pulsante successivo con il focus sul pulsante "-"
    $this.on('click', function() {
      $this.hide();
      btnQty.css({
        'display': 'flex',
        'justify-content': 'space-around'
      });
      btnQty.find('.minus').focus();
    });
  });

  // Seleziona i pulsanti "aggiungi" e "rimuovi" e associa un gestore di eventi "click"
  var toggleAddBtn = $('.js-toggle-add');
  var toggleRemoveBtn = $('.js-toggle-remove');
  var iconToggleLounge = $('#icon_toggle_lounge');
  var tooltipToggleLounge = $('#tooltip_toggle_lounge');

  toggleAddBtn.on('click', function() {
    // Aumenta il valore dell'input di 1
    var inputQty = $(this).prev('.js-qty-value');
    inputQty.val(parseInt(inputQty.val()) + 1);
    toggleRemoveBtn.prop('disabled', false);
  });

  toggleRemoveBtn.on('click', function() {
    // Diminuisce il valore dell'input di 1, ma non andare sotto lo zero
    var inputQty = $(this).next('.js-qty-value');
    var newVal = parseInt(inputQty.val()) - 1;
    if (newVal >= 0) {
      inputQty.val(newVal);
    }
    // Disabilita il pulsante "rimuovi" se il valore è 0, aggiunge la classe "active" al tooltip e rimuove la classe "active" dall'icona
    if (newVal <= 0) {
      $(this).prop('disabled', true);
      iconToggleLounge.removeClass('active');
      tooltipToggleLounge.addClass('active');
    }
  });

})(jQuery);